import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import DetailItem from '../DetailItem';
import OrderUserInfo from '../../../orders/Components/OrderUserInfo';
import OrderProp from '../../propTypes/orderProp';
import translate from '../../../../commonComponents/translate';
import { PAYMENT_METHOD } from '../../../../services/utilityFunctions';
import FormattedAddress from '../../FormattedAddress';

function InfoTabHeader(props) {
  const { t, order, isAcademy, isOpportunity } = props;

  const {
    companyBilling,
    billingAddress: orderBillingAddress,
    paymentMethodType,
    owner,
    isPaidWithCoins,
    total,
    sellerShippingAddress,
    shippingAddress,
    installationAddress,
    operator,
    shipping,
    vatNumber,
  } = order;

  const paymentMethod = useMemo(() => {
    if (isPaidWithCoins && total === 0) {
      return t('shop.checkout.coupon.coins');
    }
    return paymentMethodType ? t(`shop.${paymentMethodType}`) : 'N/A';
  }, [t, order]);

  const renderOrderAddress = useCallback(
    (address, isShippingAddress = false) => {
      let addressParam = address;
      const existInsideOfAddress =
        addressParam.firstName || addressParam.lastName;
      const existOwner = owner?.firstname || owner?.lastName || owner?.username;
      if (!existOwner && !existInsideOfAddress) {
        return `(${t('reports.marketplace.orders.user.removed')})`;
      }
      if (
        !isShippingAddress &&
        paymentMethodType === PAYMENT_METHOD.PAID_BY_COMPANY
      ) {
        addressParam = {
          ...addressParam,
          firstName: companyBilling?.name || '',
          lastName: '',
          email: companyBilling?.email || '',
          phone: companyBilling?.phone || '',
          emails: companyBilling?.emails || [],
        };
      }
      return (
        <FormattedAddress
          address={addressParam}
          showOptionalFields
          formatCompanyName={false}
        />
      );
    },
    [],
  );

  return (
    <div className="info-header">
      <div className="wrapper">
        <DetailItem
          header={t('order_detail_right.clientName')}
          isComposeText={<OrderUserInfo user={owner} />}
        />
        {!isOpportunity ? (
          <DetailItem
            header={t('order_detail_right.paymentMethod')}
            text={paymentMethod}
          />
        ) : (
          <div className="detail-item" />
        )}
        {operator ? (
          <DetailItem
            header={t('order_operator')}
            isComposeText={<OrderUserInfo user={operator} />}
          />
        ) : null}
      </div>
      <div className="wrapper">
        <DetailItem
          header={t('order_detail_right.billing')}
          text={
            orderBillingAddress
              ? renderOrderAddress({ ...orderBillingAddress, NIF: vatNumber })
              : '-'
          }
        />
        <DetailItem
          header={t('order_detail_right.shipping')}
          text={
            sellerShippingAddress || shippingAddress
              ? renderOrderAddress(
                  sellerShippingAddress || shippingAddress,
                  true,
                )
              : '-'
          }
        />
        {operator && installationAddress ? (
          <DetailItem
            header={t('order_installationAddress')}
            text={
              installationAddress
                ? renderOrderAddress(installationAddress, true)
                : '-'
            }
          />
        ) : null}
      </div>
      {shipping?.name?.length > 0 ? (
        <DetailItem
          header={t('academy.sessions.makeOrder.shippingProvider')}
          text={shipping?.name}
        />
      ) : null}
    </div>
  );
}

InfoTabHeader.propTypes = {
  t: PropTypes.func.isRequired,
  order: PropTypes.shape(OrderProp.propType).isRequired,
  isOpportunity: PropTypes.bool,
  isAcademy: PropTypes.bool,
};

InfoTabHeader.defaultProps = {
  isOpportunity: false,
  isAcademy: false,
};

export default translate(InfoTabHeader);
